<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-expansion-panels class="pa-2">
          <v-expansion-panel
            v-for="(post, index) in posts"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header>
              <span>
                <span v-if="index !== editPostTitle">
                  {{ post.title }}
                </span>
                <div class="rowinfo" v-if="index === editPostTitle">
                  <v-text-field
                    v-if="index === editPostTitle"
                    v-model="post.title"
                    append-icon="check"
                    class="my-2 contentinfo"
                    dense
                    hide-details
                    :label="$t('title')"
                    outlined
                    @click.stop
                    @click:append.stop="editPostTitle = -1"
                  />
                  <help-info
                    v-show="index === 0"
                    :element-name="`${serviceName}-${componentName}-data-editPostTitle`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('title')"
                  />
                </div>

                <v-btn
                  v-if="index !== editPostTitle"
                  icon
                  small
                  @click.stop="editPostTitle = index"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </span>
              <div class="rowinfo justify-end">
                <v-btn icon max-width="36" @click="posts.splice(index, 1)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <help-info
                  v-if="index !== editPostTitle && index === -1"
                  :element-name="`${serviceName}-${componentName}-data-selectedBlog`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('selected_blog')"
                />
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-card class="mt-12 mb-4" flat>
                <custom-tabs v-model="tabs" grow>
                  <template v-slot:staticTabs>
                    <v-tab :ripple="false">
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                        style="
                          justify-content: center !important;
                          align-items: center;
                        "
                      >
                        <div class="cornel-left"></div>
                        <div class="cornel-right"></div>
                        <v-icon class="me-2">mdi-image</v-icon>
                        {{ $t("image") }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tab-image-1`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('image')"
                        />
                      </div>
                    </v-tab>
                    <v-tab :ripple="false">
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                        style="
                          justify-content: center !important;
                          align-items: center;
                        "
                      >
                        <div class="cornel-left"></div>
                        <div class="cornel-right"></div>
                        <v-icon class="me-2">mdi-palette</v-icon>
                        {{ $t("color") }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tab-image-1`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('color')"
                        />
                      </div>
                    </v-tab>
                    <v-tab :ripple="false">
                      <div
                        class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                        style="
                          justify-content: center !important;
                          align-items: center;
                        "
                      >
                        <div class="cornel-left"></div>
                        <div class="cornel-right"></div>
                        <v-icon class="me-2">mdi-label</v-icon>
                        {{ $t("icon") }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-tab-image-1`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('icon')"
                        />
                      </div>
                    </v-tab>
                  </template>
                  <template v-slot:staticItems>
                    <v-tabs-items v-model="tabs" class="mb-3" touchless>
                      <v-tab-item>
                        <pic-selector
                          :data="post"
                          :edit-name="false"
                          one-pic
                          single
                          @change="resetOther(post, 'gallery')"
                        />
                      </v-tab-item>

                      <v-tab-item>
                        <color-pallete
                          v-model="post.color"
                          class="my-8"
                          @input="resetOther(post, 'color')"
                        />
                      </v-tab-item>

                      <v-tab-item>
                        <div
                          class="rowinfo mt-4"
                          style="width: 100% !important"
                        >
                          <icon-picker
                            v-model="post.icon"
                            @input="resetOther(post, 'icon')"
                            class="contnetinfo"
                            style="
                              max-width: 100% !important;
                              width: 100% !important;
                            "
                          />
                          <help-info
                            v-show="index === 0"
                            :element-name="`${serviceName}-${componentName}-post-icon`"
                            :service-name="serviceName"
                            :help-data="helpData"
                            class="buttoninfo"
                            :label="$t('select_icon')"
                          />
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                  </template>
                </custom-tabs>

                <div class="rowinfo">
                  <v-textarea
                    v-model="post.content"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    class="contentinfo"
                    :label="$t('text')"
                    outlined
                    rows="8"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-post-content`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('text')"
                  />
                </div>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card-actions class="px-6 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              color="success"
              class="contentinfo"
              outlined
              @click="addNewPost"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-addedFaq`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('add_blog')"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPallete from "@/view/components/colorPallete";
import PicSelector from "@/view/components/UploadCenter/picSelector";
import PicSelectorSingle from "@/view/components/UploadCenter/picSelectorSingle";
import IconPicker from "@/view/components/IconPicker";
import ImageUploader from "@/view/pages/qrland/components/imageUploader";

export default {
  name: "Blog",

  components: {
    ImageUploader,
    IconPicker,
    PicSelectorSingle,
    PicSelector,
    ColorPallete,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
    value: Array,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "Blog",
      editPostTitle: -1,
      tabs: 0,
      posts: [],
    };
  },

  mounted() {
    // console.log(this.data.blog)
    if (this.data?.blog) {
      this.posts = this.data.blog.map((post) => ({
        ...post,
      }));

      // this.posts = this.data.blog;
    } else if (this.value?.length) {
      this.posts = this.value.map((post) => ({
        ...post,
      }));
      // this.posts = this.value;
    } else {
      this.posts = [
        {
          title: this.$t("post") + " 1",
          content: "",
          gallery: [{ name: "", images: [] }],
          color: null,
          icon: null,
        },
      ];
      this.data["blog"] = this.posts;
      this.$emit("input", this.posts);
    }
  },

  watch: {
    posts: {
      deep: true,
      handler(value) {
        if (!!this.value) this.$emit("input", value);
        else if (!!this.data) this.data["blog"] = value;
      },
    },
    value: {
      deep: true,
      handler(newValue) {
        if (
          newValue?.length &&
          JSON.stringify(newValue) !== JSON.stringify(this.posts)
        ) {
          this.posts = newValue.map((post) => ({
            ...post,
          }));
        }
      },
    },
    data: {
      deep: true,
      handler(newData) {
        if (
          newData?.blog &&
          JSON.stringify(newData.blog) !== JSON.stringify(this.posts)
        ) {
          this.posts = newData.blog.map((post) => ({
            ...post,
          }));
        }
      },
    },
    "$i18n.locale": {
      handler() {
        this.posts = this.posts.map((post, index) => ({
          ...post,
          title: post.title.includes(this.$t("post"))
            ? this.$t("post") + " " + (index + 1)
            : post.title,
        }));
      },
    },
  },

  methods: {
    addNewPost() {
      this.posts.push({
        title: this.$t("post") + " " + (this.posts.length + 1),
        content: "",
        gallery: [{ name: "", images: [] }],
        color: undefined,
        icon: undefined,
      });
    },
    resetOther(post, name) {
      this.$nextTick(() => {
        const current = post[name];

        post.gallery = [{ name: "", images: [] }];
        post.color = undefined;
        post.icon = undefined;

        post[name] = current;
      });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}
</style>
